<div class="yaml-editor-container">
  <app-editor [formControl]="formControl" [formlyAttributes]="field" [theme]="theme" mode="yaml"></app-editor>
  <!--<textarea fd-form-control [formControl]="formControl" [formlyAttributes]="field" placeholder="Enter YAML..." style="width: 90%; height: 8.5rem" fdCompact></textarea>-->
</div>
